module.exports = __webpack_public_path__ + "img/source-sans-pro-v13-latin-300.fb982ea4.svg";